import { useQuery } from 'react-query'
import { useParams } from 'react-router-dom'
import { showError } from '../../../../../../../_metronic/helpers'
import { PageHeading, StatCardItem, StatCards } from '../../../../../../components'
import { getFaturaProfissionalById } from '../../../faturas-profissional-list/core/_requests'
import { SituacaoFaturaBadge } from '../../../faturas-list/components/SituacaoFaturaBadge'
import { useT } from '_metronic/i18n/Metronici18n'

/**
 * Resumo da fatura do profissional acima dos itens: instituição como título, competência e data
 * como apoio; situação, valor a receber e quantidade de atendimentos em cards.
 */
export const FaturaProfissionalResumo = () => {
  const { t } = useT()
  const { idFatura } = useParams<{ idFatura: string }>()

  const { data: fatura } = useQuery(
    ['fatura-profissional', idFatura],
    () => getFaturaProfissionalById(Number(idFatura)),
    { enabled: Boolean(idFatura), refetchOnWindowFocus: false, onError: showError }
  )

  const { mesSigla, ano } = fatura?.mesAno ?? {}
  const competencia = mesSigla && ano ? `${mesSigla}/${ano}` : undefined

  const stats: StatCardItem[] = [
    { label: t('situacao.label'), value: <SituacaoFaturaBadge situacao={fatura?.situacao} /> },
    { label: t('cols.valor_receber'), value: fatura?.valorFormatado },
    { label: t('cols.quantidade'), value: fatura?.quantidade },
  ]

  return (
    <>
      <PageHeading
        title={fatura ? fatura.empresa?.nomeFantasia || t('fatura.label') : 'Carregando fatura…'}
        description={
          [competencia && `${t('periodo.label')}: ${competencia}`, fatura?.dataFormatada]
            .filter(Boolean)
            .join(' · ') || undefined
        }
      />
      <StatCards items={stats} ariaLabel='Resumo da fatura' />
    </>
  )
}
